module.exports = __webpack_public_path__ + "static/media/290832.3243b6b8.png";